<template>
    <div>
        <Form :ref="modelSettle.form.ref" :model="modelSettle.form.params" :rules="modelSettle.form.rules" :label-width="120">
            <Row>
                <Col span="24" style="margin-bottom: 10px">
                    <Button type="primary" @click.native="RefreshConfig">更新配置</Button>
                </Col>
                <Col span="10">
                    <FormItem label="分组平台:" prop="plat_ids">
                        <Select v-model="modelSettle.form.params.plat_ids" filterable multiple clearable placeholder="选择分组平台同步" style="min-width: 200px">
                            <Option v-for="(item, index) in select.platformList" :value="item.id" :label="item.name" :key="index">
                                {{ item.name }}
                                <span style="color: #bbb">({{ item.id }})</span>
                            </Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="24">
                    <FormItem label="风控配置同步:">
                        <Checkbox :disabled="modelSettle.form.params.is_default == 1" :indeterminate="modelSettle.form.checkBox.indeterminate" :value="modelSettle.form.checkBox.checkAll" @click.prevent.native="handleCheckAll">全选</Checkbox>
                        <CheckboxGroup v-model="modelSettle.form.params.refresh_cfg" @on-change="checkAllGroupChange">
                            <Checkbox :label="1" :disabled="modelSettle.form.params.is_default == 1">玩家风控buff配置</Checkbox>
                            <Checkbox :label="2" :disabled="modelSettle.form.params.is_default == 1">游戏风控库</Checkbox>
                            <Checkbox :label="3" :disabled="modelSettle.form.params.is_default == 1">智能风控库</Checkbox>
                            <Checkbox :label="4" :disabled="modelSettle.form.params.is_default == 1">IP黑名单管理</Checkbox>
                            <Checkbox :label="5" :disabled="modelSettle.form.params.is_default == 1">手机号码黑名单管理</Checkbox>
                            <Checkbox :label="6" :disabled="modelSettle.form.params.is_default == 1">转出用户限制管理</Checkbox>
                            <Checkbox :label="9" :disabled="modelSettle.form.params.is_default == 1">白名单玩家管理</Checkbox>
                            <Checkbox :label="10" :disabled="modelSettle.form.params.is_default == 1">黑名单转出信息</Checkbox>
                            <Checkbox :label="11" :disabled="modelSettle.form.params.is_default == 1">异常特征库</Checkbox>
                        </CheckboxGroup>
                    </FormItem>
                </Col>
            </Row>
        </Form>
    </div>
</template>
<script>
import { GetAllPlatform, RefreshConfig } from '@/api/admin/risk'
export default {
    name: 'configSync',
    data() {
        return {
            select: {
                platform: 0,
                platformList: [] //操作分类
            },
            //同步配置
            modelSettle: {
                show: false,
                form: {
                    checkBox: {
                        indeterminate: false,
                        checkAll: false,
                        checkAllGroup: new Array()
                    },
                    agent_no: 0,
                    ref: 'modelSettle_form',
                    params: {
                        start_time: '',
                        end_time: '',
                        fee_type: 1,
                        plat_ids: new Array(),
                        refresh_cfg: new Array(),
                        max_put: 0,
                        min_put: 0,
                        day_max_put: 0,
                        put_fee: 0,
                        max_fee: 0
                    },
                    params1: {},
                    rules: {
                        plat_ids: [
                            {
                                required: true,
                                trigger: 'change',
                                validator: (rule, value, callback) => {
                                    if (value && value.length > 0) {
                                        callback()
                                    } else {
                                        callback('请选择分组平台')
                                    }
                                }
                            }
                        ]
                    }
                }
            }
        }
    },
    methods: {
        //多选
        checkAllGroupChange(data) {
            let checkAll = data.length === 3
            let indeterminate = data.length > 0 && !checkAll
            Object.assign(this.modelSettle.form.checkBox, {
                indeterminate,
                checkAll
            })
        },
        //全选
        handleCheckAll() {
            if (this.modelSettle.form.checkBox.indeterminate) {
                this.modelSettle.form.checkBox.checkAll = false
            } else {
                this.modelSettle.form.checkBox.checkAll = !this.modelSettle.form.checkBox.checkAll
            }
            this.modelSettle.form.checkBox.indeterminate = false

            if (this.modelSettle.form.checkBox.checkAll) {
                this.modelSettle.form.params.refresh_cfg = [1, 2, 3, 4, 5, 6, 7, 9, 10, 11]
            } else {
                this.modelSettle.form.params.refresh_cfg = []
            }
        },
        GetAllPlatform() {
            GetAllPlatform({}).then((res) => {
                this.select.platformList = res._param.data || []
                if (this.select.platformList.length > 0) {
                    let initPlatId = [this.select.platformList[0].id]
                    this.modelSettle.form.params.plat_ids = initPlatId
                }
            })
        },
        RefreshConfig() {
            let params = {
                plat_ids: this.modelSettle.form.params.plat_ids,
                refresh_cfg: this.modelSettle.form.params.refresh_cfg
            }
            if (!this.modelSettle.form.params.refresh_cfg.length) {
                this.$Message.error('至少选择一个选项!')
                return
            }
            this.$refs[this.modelSettle.form.ref].validate((valid) => {
                if (valid) {
                    RefreshConfig(params).then((res) => {
                        this.$Message.success('更新成功')
                    })
                }
            })
        }
    },
    created() {
        this.GetAllPlatform()
    }
}
</script>
<style lang="less" scoped>
.btn_batch {
    margin-right: 12px;
}
</style>
